export default __webpack_public_path__ + "4d4883c639682069893e396df260e639.png";